// Campi della pratica per categoria (variazioni paghe): la tabella arriva dal server con /scadenze/tipi, così regole
// e messaggi sono gli stessi del salvataggio lato server.
// Tipologie ammesse: solo queste cinque. Il lavoro intermittente nel database è "intermittente": det./indet. si ricava dalla scadenza.
export const TIPI_CONTRATTO = {
  tempo_determinato: 'T.Det.', tempo_indeterminato: 'T.Indet.', apprendistato: 'Apprendistato',
  intermittente_det: 'Intermittente det.', intermittente_indet: 'Intermittente indet.',
};
export const eIntermittente = v => typeof v === 'string' && v.startsWith('intermittente');
// Tipologia di una riga salvata (valore del modulo); i vecchi valori fuori dalle cinque voci non si mostrano
export function tipologiaDaRiga(r) {
  if (!r) return '';
  if (r.tipo_contratto === 'intermittente') return r.data_scadenza ? 'intermittente_det' : 'intermittente_indet';
  return TIPI_CONTRATTO[r.tipo_contratto] ? r.tipo_contratto : '';
}
export const ORARI = { full_time: 'Full Time', part_time: 'Part Time' };
export const NON_DEFINITO = 'Non definito';

// Tipo di trasformazione (categoria Trasformazione): stesso elenco del server. "Altro" ha un testo libero e si salva come "Altro: testo".
export const TIPI_TRASFORMAZIONE = ['da T.Det. a T.Indet.', 'da Full Time a Part Time', 'da Part Time a Full Time', 'variazione ore', 'da Apprendistato a T.Indet.'];
export const ALTRO = 'Altro';
const VECCHIE_TRASFORMAZIONI = { 'da t.det. a t.indet.': TIPI_TRASFORMAZIONE[0], 'da f.t. a p.t.': TIPI_TRASFORMAZIONE[1], 'da p.t. a f.t.': TIPI_TRASFORMAZIONE[2] };
// Valore salvato -> { scelta, testo } per il menu e il testo libero (le vecchie diciture si mostrano come le nuove; un testo sconosciuto vale "Altro")
export function leggiTipoTrasformazione(v) {
  const t = String(v ?? '').trim();
  if (!t) return { scelta: '', testo: '' };
  if (TIPI_TRASFORMAZIONE.includes(t)) return { scelta: t, testo: '' };
  if (VECCHIE_TRASFORMAZIONI[t.toLowerCase()]) return { scelta: VECCHIE_TRASFORMAZIONI[t.toLowerCase()], testo: '' };
  const m = t.match(/^altro\s*(?::\s*(.*))?$/i);
  return { scelta: ALTRO, testo: m ? (m[1] || '').trim() : t };
}
export const scriviTipoTrasformazione = (scelta, testo) => (scelta === ALTRO ? (String(testo || '').trim() ? `${ALTRO}: ${String(testo).trim()}` : ALTRO) : scelta);
// Testo per tabella e riepiloghi
export function etichettaTipoTrasformazione(v) {
  const { scelta, testo } = leggiTipoTrasformazione(v);
  return scelta === ALTRO ? (testo ? `${ALTRO}: ${testo}` : ALTRO) : scelta;
}

const vuoto = v => v === null || v === undefined || String(v).trim() === '';

// { mostra: Set, richiesti: Set } per la categoria scelta; senza regole (altri tipi) nessun campo della pratica
export function regolaDi(tipi, tipoId, categoriaId) {
  const tipo = (tipi.tipi || []).find(t => String(t.id) === String(tipoId));
  const categoria = (tipi.categorie || []).find(c => String(c.id) === String(categoriaId));
  const r = tipo && tipo.chiave === 'variazione_paghe' && categoria && tipi.campi ? tipi.campi.categorie[categoria.chiave] : null;
  return { mostra: new Set(r ? r.mostra : []), richiesti: new Set(r ? r.richiesti : []), richiestoSe: r ? (r.richiestoSe || {}) : {}, esentiSe: r ? (r.esentiSe || {}) : {}, etichette: r ? (r.etichette || {}) : {} };
}

export function richiestiConCondizioni(regola, valori) {
  const richiesti = new Set(regola.richiesti);
  for (const [campo, cond] of Object.entries(regola.richiestoSe)) {
    if (Object.entries(cond).every(([k, ammessi]) => ammessi.includes(valori[k]))) richiesti.add(campo);
  }
  for (const [campo, cond] of Object.entries(regola.esentiSe || {})) {
    if (Object.entries(cond).every(([k, ammessi]) => ammessi.includes(valori[k]))) richiesti.delete(campo);
  }
  return richiesti;
}

// Etichette dei campi richiesti e ancora vuoti (stessa logica del server)
export function mancanti(tipi, regola, v) {
  const etichette = (tipi.campi && tipi.campi.etichette) || {};
  return [...richiestiConCondizioni(regola, v)].filter((campo) => {
    if (campo === 'lavoratore') return vuoto(v.lavoratore_cognome) || vuoto(v.lavoratore_nome);
    if (campo === 'stagionale') return v.stagionale !== true && v.stagionale !== false;
    if (campo === 'ore_settimanali') return !(Number(v.ore_settimanali) > 0);
    return vuoto(v[campo]);
  }).map(c => (regola.etichette && regola.etichette[c]) || etichette[c] || c);
}
